import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_SUSTAINABLE_RETURN: MijnRoute = {
    path: ':id/duurzaam-rendement',
    navigationEvent: 'toSustainableReturn',
    regex: /^\/beleggen\/[^/]+\/duurzaam-rendement$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/duurzaam-rendement'
};
